import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withRouter } from "react-router";

import { setPageName, ToggleCart } from '../../redux/cart/cart.action';
import { selectEmptyCartPop, selectToggle, selectStationToggle } from '../../redux/cart/cart.selector';

import './overlay.style.css';

class overlay extends React.Component {

    componentDidUpdate() {
        if (this.props.position === true) {
            document.body.classList.add('overlay-hide');
        }
        if (this.props.position === false) {
            document.body.classList.remove('overlay-hide');
        }
        if (this.props.position === false && this.props.page === 'Station Details') {
            document.body.classList.add('overlay-hide');
        }
        if (this.props.hideStation === true && this.props.page === 'Station List') {
            document.body.classList.remove('overlay-hide');
        }
        if (this.props.hideStation === false && this.props.page === 'Station List') {
            document.body.classList.add('overlay-hide');
        }
        if (this.props.emptyPop !== '') {
            document.body.classList.add('overlay-hide');
        }
    }
    componentWillUnmount(){
        if (this.props.hideStation === false && this.props.page === 'Station List') {
            document.body.classList.remove('overlay-hide');
        }
        if (this.props.hideStation === true && this.props.page === 'Station List') {
            document.body.classList.add('overlay-hide');
        }
    }
    UNSAFE_componentWillMount(){
        
        if (this.props.hideStation === true && this.props.page === 'Station List') {
            document.body.classList.remove('overlay-hide');
        }
        if (this.props.hideStation === false && this.props.page === 'Station List') {
            document.body.classList.add('overlay-hide');
        }
    }
    popupClose = () => {
        if (this.props.page === 'Journey Details') {
            this.props.toggleCart()
        }
        if (this.props.page === 'Station Details') {
            this.props.setPage('Journey Details');
        }

    }
    render() {

        const { page, position, emptyPop } = this.props;

        if (page && (page === 'Station Details' || page === 'Journey Details'|| page === 'All Station List')) {

            return (
                <div id="layer" className={`overlay ${(position === true || page === 'Station Details' || emptyPop !== '') ? 'active' : ''}`} onClick={() => this.popupClose()}>
                </div>
            )
        } else {

            return (
                <div id="layer" className="overlay active" onClick={() => this.props.history.push('/m/buy-food-in-train/')} >
                </div>
            )
        }
    }
}

const mapStateToProps = createStructuredSelector({
    position: selectToggle,
    emptyPop: selectEmptyCartPop,
    hideStation: selectStationToggle,
})

const mapDispatchToProps = dispatch => ({
    setPage: page => dispatch(setPageName(page)),
    toggleCart: () => dispatch(ToggleCart()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(overlay));